import React from 'react';
import styles from 'Custom/FAQ/index.module.scss';
import RawAccordion from 'Nori/Accordion';

const FAQDropdown = ({ className = '', ...props }) => (
  <RawAccordion className={`${styles.faqAccordion}`} {...props} />
);

export default FAQDropdown;
